import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLinkSvg } from "./IconLinkSvg.mjs";
const IconLink = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLinkSvg, ...iconProps });
};
export {
  IconLink
};
